require('../../modules/es6.math.sinh');
module.exports = require('../../modules/_core').Math.sinh;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/math/sinh.js
// module id = 1448
// module chunks = 0